namespace RioERP.Orders {
    export interface OrdershippingBooksForm {
        OrderId: Serenity.LookupEditor;
        ProductId: Serenity.LookupEditor;
        ProductBookid: Serenity.LookupEditor;
        Quantity: Serenity.IntegerEditor;
    }

    export class OrdershippingBooksForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.OrdershippingBooks';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrdershippingBooksForm.init)  {
                OrdershippingBooksForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(OrdershippingBooksForm, [
                    'OrderId', w0,
                    'ProductId', w0,
                    'ProductBookid', w0,
                    'Quantity', w1
                ]);
            }
        }
    }
}
